import './_loading.scss';
import VStore from "../../store";
import {useEffect} from "react";
const Loading = () => {
    const {isLoading, setIsLoading} = VStore();

    useEffect(() => {
        window.addEventListener('message', (event) => {
          if (event.data.target === 'v3d-app' && event.data.type === 'loaded') {
            setIsLoading(false);
          }
        })
    }, []);

    return (
        <div className={"loading" + (isLoading ? " show" : '')}>
            <div className="loading__container">
                <img src="./envision/assets/images/ellipse.png" alt="loading"/>
            </div>
        </div>
    )
}

export default Loading;
